import { cn } from '@restworld/utils-common';

export const MainWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('w-full', className)} {...props} />
);
export const InnerWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'max-w-screen-sm px-4 pt-8 pb-0 mx-auto flex flex-col justify-between text-center md:px-8',
      className
    )}
    {...props}
  />
);
